module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-renew-form",
    attrs: {
      "width": "850px",
      "title": "续费",
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.myVisible = $event
      },
      "close": _vm.handerClose
    }
  }, [(_vm.myDetail) ? _c('div', {
    staticClass: "renew-content"
  }, [_c('section', {
    staticClass: "renew-bd"
  }, [_c('el-table', {
    staticClass: "selected-product-tab",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "tooltip-effect": "dark",
      "data": [_vm.myDetail],
      "empty-text": "还没有选择产品"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "logo",
      "header-align": "center",
      "align": "center",
      "width": "100px",
      "label": "产品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "tpimg",
          attrs: {
            "src": scope.row.logo,
            "alt": scope.row.logo
          }
        })]
      }
    }], null, false, 2004791488)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseNum",
      "label": "购买数量",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [_c('span', [_vm._v(_vm._s(row.purchaseNum))])]
      }
    }], null, false, 1458136111)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "单价(元)",
      "min-width": "100",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "price"
        }, [_vm._v(_vm._s(scope.row.price.toLocaleString()))])]
      }
    }], null, false, 1758458025)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseMonth",
      "label": "续费时长(月)",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [_c('el-input-number', {
          attrs: {
            "min": 1,
            "size": "small",
            "step-strictly": true,
            "controls-position": "right"
          },
          on: {
            "change": _vm.handleChangeNum
          },
          model: {
            value: (row.purchaseMonth),
            callback: function($$v) {
              _vm.$set(row, "purchaseMonth", $$v)
            },
            expression: "row.purchaseMonth"
          }
        })]
      }
    }], null, false, 1583599189)
  })], 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "order-add-ft",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "order-evaluate",
    staticStyle: {
      "color": "#EB6264"
    },
    attrs: {
      "label": "预估价格:"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.evaluatePrice) + " 元\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "order-total",
    attrs: {
      "label": "订单总价:"
    }
  }, [_c('el-input', {
    staticClass: "price",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "oninput": "this.value=this.value.replace(/[^\\d]/g,'');"
    },
    model: {
      value: (_vm.totalPrice),
      callback: function($$v) {
        _vm.totalPrice = $$v
      },
      expression: "totalPrice"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("元")])], 2)], 1)], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.myDetail) ? _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmit(_vm.myDetail)
      }
    }
  }, [_vm._v("提交")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b635588"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/orderList/ModalFormOrder.vue
// module id = 1732
// module chunks = 9